import { webTextStyles, FontWeights, displayTextStyles, displayWebTextStyes } from "../../constants.js";
import { RemSizes } from "../../utils.js";
import { palette } from "../Palette/paletteTheme.js";
const typography = {
  /** Web */
  LargeTitle: {
    fontSize: RemSizes(34),
    lineHeight: webTextStyles.largeTitle.lineHeight
  },
  Title1: {
    fontSize: RemSizes(28),
    lineHeight: webTextStyles.title1.lineHeight,
    letterSpacing: webTextStyles.title1.letterSpacing
  },
  Title2: {
    fontSize: RemSizes(22),
    lineHeight: webTextStyles.title2.lineHeight,
    letterSpacing: webTextStyles.title2.letterSpacing
  },
  Title3: {
    fontSize: RemSizes(20),
    lineHeight: webTextStyles.title3.lineHeight,
    letterSpacing: webTextStyles.title3.letterSpacing
  },
  Headline: {
    fontSize: RemSizes(17),
    lineHeight: webTextStyles.headline.lineHeight,
    letterSpacing: webTextStyles.headline.letterSpacing,
    fontWeight: FontWeights.BOLD
  },
  Body: {
    fontSize: RemSizes(17),
    lineHeight: webTextStyles.body.lineHeight,
    letterSpacing: webTextStyles.body.letterSpacing
  },
  Callout: {
    fontSize: RemSizes(16),
    lineHeight: webTextStyles.callout.lineHeight,
    letterSpacing: webTextStyles.callout.letterSpacing
  },
  Subhead: {
    fontSize: RemSizes(15),
    lineHeight: webTextStyles.subHead.lineHeight,
    letterSpacing: webTextStyles.subHead.letterSpacing
  },
  Footnote: {
    fontSize: RemSizes(13),
    lineHeight: webTextStyles.footnote.lineHeight,
    letterSpacing: webTextStyles.footnote.letterSpacing
  },
  Caption1: {
    fontSize: RemSizes(12),
    lineHeight: webTextStyles.caption1.lineHeight
  },
  Caption2: {
    fontSize: RemSizes(11),
    lineHeight: webTextStyles.caption2.lineHeight
  },
  Navigation: {
    fontSize: RemSizes(9),
    lineHeight: webTextStyles.navigation.lineHeight
  },
  /** Display Text */
  DisplayXLarge: {
    fontSize: RemSizes(72),
    lineHeight: displayTextStyles.xLargeDisplay.lineHeight,
    letterSpacing: displayTextStyles.xLargeDisplay.letterSpacing
  },
  DisplayLarge: {
    fontSize: RemSizes(64),
    lineHeight: displayTextStyles.largeDisplay.lineHeight,
    letterSpacing: displayTextStyles.largeDisplay.letterSpacing
  },
  CTALarge: {
    fontSize: RemSizes(36),
    lineHeight: displayTextStyles.largeCTA.lineHeight
  },
  CTAMedium: {
    fontSize: RemSizes(24),
    lineHeight: displayTextStyles.mediumCTA.lineHeight
  },
  TitleLarge: {
    fontSize: RemSizes(20),
    lineHeight: displayTextStyles.largeTitle.lineHeight
  },
  TitleMedium: {
    fontSize: RemSizes(17),
    lineHeight: displayTextStyles.mediumTitle.lineHeight
  },
  TitleSmall: {
    fontSize: RemSizes(16),
    lineHeight: displayTextStyles.smallTitle.lineHeight
  },
  ButtonLarge: {
    fontSize: RemSizes(14),
    lineHeight: displayTextStyles.largeButton.lineHeight
  },
  ButtonMedium: {
    fontSize: RemSizes(12),
    lineHeight: displayTextStyles.mediumButton.lineHeight
  },
  ButtonSmall: {
    fontSize: RemSizes(10),
    lineHeight: displayTextStyles.smallButton.lineHeight
  },
  /** Display Web Text for Sezzle.com website (Satoshi) */
  DisplayBlackLarge: {
    fontSize: RemSizes(72),
    fontWeight: FontWeights.HEAVY,
    color: palette.primary.main,
    lineHeight: displayWebTextStyes.displayLarge.lineHeight
  },
  DisplayBoldLarge: {
    fontSize: RemSizes(72),
    fontWeight: FontWeights.BOLD,
    color: palette.primary.main,
    lineHeight: displayWebTextStyes.displayLarge.lineHeight
  },
  DisplayBlackRegular: {
    fontSize: RemSizes(62),
    fontWeight: FontWeights.HEAVY,
    color: palette.primary.main,
    lineHeight: displayWebTextStyes.displayRegular.lineHeight
  },
  DisplayBoldRegular: {
    fontSize: RemSizes(62),
    lineHeight: displayWebTextStyes.displayRegular.lineHeight,
    fontWeight: FontWeights.BOLD,
    color: palette.primary.main
  },
  HeadlineLarge: {
    fontSize: RemSizes(52),
    lineHeight: displayWebTextStyes.headlineLarge.lineHeight,
    fontWeight: FontWeights.BOLD,
    color: palette.primary.main
  },
  HeadlineMedium: {
    fontSize: RemSizes(42),
    fontWeight: FontWeights.BOLD,
    color: palette.primary.main,
    lineHeight: displayWebTextStyes.headlineMedium.lineHeight
  },
  HeadlineSmall: {
    fontSize: RemSizes(32),
    lineHeight: displayWebTextStyes.headlineSmall.lineHeight,
    fontWeight: FontWeights.BOLD,
    color: palette.primary.main
  },
  SubHeadBoldLarge: {
    fontSize: RemSizes(32),
    fontWeight: FontWeights.BOLD,
    color: palette.primary.main,
    lineHeight: displayWebTextStyes.subHeadBoldLarge.lineHeight
  },
  SubHeadRegularLarge: {
    fontSize: RemSizes(32),
    fontWeight: FontWeights.NORMAL,
    color: palette.primary.main,
    lineHeight: displayWebTextStyes.subHeadRegularLarge.lineHeight
  },
  SubHeadBoldSmall: {
    fontSize: RemSizes(21),
    fontWeight: FontWeights.BOLD,
    color: palette.primary.main,
    lineHeight: displayWebTextStyes.subHeadSmall.lineHeight
  },
  SubHeadRegularSmall: {
    fontSize: RemSizes(21),
    fontWeight: FontWeights.NORMAL,
    color: palette.primary.main,
    lineHeight: displayWebTextStyes.subHeadSmall.lineHeight
  },
  BodyRegular: {
    fontSize: RemSizes(18),
    fontWeight: FontWeights.NORMAL,
    color: palette.primary.main,
    lineHeight: displayWebTextStyes.bodyRegular.lineHeight
  },
  BodyDisclaimer: {
    fontSize: RemSizes(12),
    fontWeight: FontWeights.NORMAL,
    color: palette.primary.main,
    lineHeight: displayWebTextStyes.bodyDisclaimer.lineHeight
  },
  CTAButtonText: {
    fontSize: RemSizes(21),
    lineHeight: displayWebTextStyes.ctaButtonText.lineHeight,
    fontWeight: FontWeights.BOLD,
    color: palette.primary.main
  },
  TextLinkStandard: {
    fontSize: RemSizes(18),
    fontWeight: FontWeights.BOLD,
    color: palette.secondary.main,
    lineHeight: displayWebTextStyes.textLinkStandard.lineHeight,
    textDecorationLine: displayWebTextStyes.textLinkStandard.textDecorationLine
  },
  TextLinkDisclaimer: {
    fontSize: RemSizes(12),
    fontWeight: FontWeights.BOLD,
    color: palette.secondary.main,
    lineHeight: displayWebTextStyes.textLinkDisclaimer.lineHeight,
    textDecorationLine: displayWebTextStyes.textLinkDisclaimer.textDecorationLine
  }
};
export {
  typography
};
//# sourceMappingURL=theme.js.map
